module.exports = __webpack_public_path__ + "static/media/GESSTwoMedium-Medium.281dded1.woff2";